<template>
  <div class="out_wrap">
    <div class="back_wrap">
      <el-button @click="$router.go(-1)"><i class="el-icon-arrow-left" />返回</el-button><span class="fs16 bold ml20">权限配置：{{ $route.query.name || '-' }}</span>
    </div>
    <el-tabs v-model="activeTab" type="border-card">
      <el-tab-pane name="func" label="功能权限">
        <p class="all mb22">
          <el-checkbox :value="allFuncChecked" :indeterminate="allIndeterminate" :disabled="id == 1" @change="allFuncCheck">全选</el-checkbox>
        </p>
        <div v-for="(item, index) in funcOptions" :key="index" class="func_item flex">
          <div class="first">
            <CheckboxParentItem
              :value="item"
              :checked-ids="auth_node"
              :children="item.children"
              @change="handleChangeParentItem"
            />
          </div>
          <div class="flex1">
            <CheckBoxItem
              v-for="(list, i) in item.children"
              :key="i"
              :value="list"
              :checked-ids="auth_node"
              :p-value="item"
              :children="item.children"
              @change="handleChangeItem"
            />
          </div>
        </div>
        <div class="center"><el-button type="primary" @click="saveFunc">保存</el-button></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import CheckBoxItem from './components/CheckboxItem.vue'
import CheckboxParentItem from './components/CheckboxParentItem.vue'
import { roleAuth, nodeList, setroleNode } from '@/api/accountInfo'
export default {
  components: {
    CheckBoxItem,
    CheckboxParentItem
  },
  data() {
    return {
      id: this.$route.query.id || '',
      activeTab: 'func',
      // 所有节点
      funcOptions: [],
      // 所有权限id集合
      auth_node: []
    }
  },
  computed: {
    allFuncChecked() {
      return this.allIds.every(item => this.auth_node.includes(item))
    },
    allIndeterminate() {
      return this.allIds.length > this.curAllPids.length && this.curAllPids.length > 0
    },
    allIds() {
      // 所有ids
      const ids = []
      this.funcOptions.forEach(item => {
        ids.push(item.node_id)
        if (item.children && item.children.length) {
          item.children.forEach(list => {
            ids.push(list.node_id)
          })
        }
      })
      return ids
    },
    curAllPids() {
      return this.allIds.filter(item => this.auth_node.includes(item))
    }
  },
  created() {
    this.queryFuncNode()
    this.roleAuthFn()
  },
  methods: {
    handleChangeItem(val) {
      this.auth_node = val
      console.log(this.auth_node, 'this.auth_node')
    },
    handleChangeParentItem(val) {
      this.auth_node = val
      console.log(this.auth_node, 'this.auth_node')
    },
    allFuncCheck(checked) {
      if (checked) {
        this.auth_node = this.allIds
      } else {
        this.auth_node = []
      }
    },
    queryFuncNode() {
      nodeList().then(res => {
        if (res.code === 200) {
          this.funcOptions = res.data
        }
      })
    },
    roleAuthFn() {
      // 获取角色对应的权限
      roleAuth({ role_id: this.$route.query.id }).then(res => {
        if (res.code === 200) {
          this.auth_node = res.data.auth_node
        }
      })
    },
    saveFunc() {
      if (!this.auth_node.length) {
        this.$message('请至少选择一个权限')
        return false
      }
      setroleNode({ role_id: this.$route.query.id, node_ids: this.auth_node }).then(res => {
        if (res.code === 200) {
          this.$message({ type: 'success', message: '设置成功' })
          this.queryFuncNode()
          this.roleAuthFn()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.all{
  .el-checkbox{
    font-weight: bold;
  }
  .el-checkbox__label{
    font-size: 16px;
  }
}
.func_item{
  border-bottom: 1px solid #EBEEF5;
  padding-bottom: 10px;
  margin-bottom: 10px;
  .first{
    width: 250px;
    margin-right: 20px;
    padding-left: 15px;
  }
  .el-checkbox{
    margin: 6px 15px;
  }
}
::v-deep{
  .el-tabs__item{
  height: 40px;
  line-height: 40px;
}
}
</style>
